<template>
  <div class="col-12" :style="style">
    <q-toolbar class="toolbar-bottom">
      <q-item-label class="portal-title ft-family-01" :data-i18n="dataI18n">
        <Ti18n :code="this.title"></Ti18n>
      </q-item-label>
      <q-space/>
      <slot name="right-actions"></slot>
    </q-toolbar>
  </div>
  <br>
</template>

<script>

import {useAuthStore} from '@core/stores/authStore';
import {mapStores} from "pinia";
import {useLayoutStore} from '@core/stores/layoutStore';
import Ti18n from "@core/components/i18n/Ti18n.vue";

export default {
  name: "generic-title",
  props: {
    title: String,
    dataI18n : String,
    style: {type :String, default : 'padding-top: 50px'}
  },
  data() {
    return {};
  },
  methods: {},
  components: {Ti18n},
  computed: {
    ...mapStores(useAuthStore, useLayoutStore),
  },
  created() {
  },

};
</script>

<style lang="scss" scoped>
.toolbar-bottom {
  border-bottom: 1px solid $app
}
.portal-title {
  font-weight: bold;
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 100%;
}
</style>
